import { useEffect, useState } from "react";
import styled from "styled-components";
import IconArrow from "../../assets/images/icon-arrow-3.svg";
import IconEdit from "../../assets/images/icon-edit.svg";
import IconDelete from "../../assets/images/icon-delete.svg";
import { formatDateByString } from "../../utils/default";
import IconEye from "../../assets/images/icon-eye-open.svg";
import IconEyeGreen from "../../assets/images/icon-eye-open-green.svg";

const Container = styled.div`
    width: 100%;
    overflow-y: auto;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    .header-table-box {
        height: 52px;
        background-color: #F2F5FE;

        .header-div {
            cursor: pointer;
        }

        th {
            color: #25368D;
            font-size: 15px;
            font-weight: 500;
            line-height: 22.43px;
            text-align: left;
            padding: 0px 16px;
        }

        .width-100 {
            width: 100%;
        }

        .width-60 {
            width: 60%;
        }

        .width-20 {
            width: 20%;
        }

        .width-180px {
            width: calc(180px - 32px);
            max-width: calc(180px - 32px);
            min-width: calc(180px - 32px);
        }

        .width-160px {
            width: calc(160px - 32px);
            max-width: calc(160px - 32px);
            min-width: calc(160px - 32px);
        }

        .width-70px {
            width: calc(70px - 32px);
            max-width: calc(70px - 32px);
            min-width: calc(70px - 32px);
        }

        .image-arrow {
            margin-left: 8px;
            transition: all 0.3s ease;

            &.open {
                transform: rotateX(180deg);
            }
        }

    }

    .row-table-box {

        td {
            padding: 24px 16px;
            border-width: 0px 0px 1px 0px;
            border-style: solid;
            border-color: #F2F2F2;
            color: #505050;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;
        }

        .icon-view {
            cursor: pointer;
            width: 20px;
            margin-right: 2px;
        }

        .icon-edit {
            cursor: pointer;
            width: 16px;
        }

        .icon-delete {
            cursor: pointer;
            width: 28px;
        }

        .icon-type-box {
            width: 28px;
            min-width: 28px;
            height: 28px;
            border-radius: 50%;
            background-color: #E3E9FD;
        }

        .dropdown {
            width: 100%;
            height: 30px;
            color: #505050;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;
            border-radius: 24px;

            &.ACTIVE {
                background-color: #DFF7F1;
            }

            &.INACTIVE {
                background-color: #F7F7FD;
            }
        }

        .status-line {
            width: 100%;
            color: #505050;
            font-size: 15px;
            font-weight: 400;
            line-height: 22.43px;
            text-align: left;

            .status-box {
                width: 14px;
                height: 14px;
                border-radius: 4px;
                margin-top: 1px;
                margin-right: 8px;

                &.ACTIVE {
                    background-color: #69D85F;
                }

                &.INACTIVE {
                    background-color: #D6DFE8;
                }
            }
        }

        .action-box {
            gap: 4px;
        }
    }
`;

function TableLocationComponent({
    listData,
    order,
    onUpdate,
    onDelete,
    onOrder,
    onOpenList,
}) {
    const [orderOption, setOrderOption] = useState({
        order: "DESC",
        orderBy: "location_name",
    })
    const [rows, setRows] = useState([
        {
            id: "",
            location_name: "",
            province: "",
            latitude: "",
            longitude: "",
            created_at: "",
        },
    ])

    useEffect(() => {
        if (Array.isArray(listData)) {
            let list = JSON.parse(JSON.stringify(listData));
            list = list.map(x => {
                let detail = {
                    ...x,
                    id: x.location_location_id,
                    location_id: x.location_location_id,
                    location_name: x.location_location_name,
                    province: x.location_province,
                    latitude: x.location_latitude,
                    longitude: x.location_longitude,
                    created_at: x.location_created_at ? formatDateByString(x.location_created_at, "DD MMMM YYYY HH:mm:ss") : "",
                }
                return detail
            })
            setRows(list)
        } else {
            setRows([])
        }
    }, [listData])
    useEffect(() => {
        if (order) {
            setOrderOption(order)
        }
    }, [order])

    function handleSort(key) {
        let detail = { ...orderOption };
        if (detail.orderBy === key) {
            detail.order = detail.order === "ASC" ? "DESC" : "ASC";
        } else {
            detail.orderBy = key;
            detail.order = "DESC";
        }
        setOrderOption(detail);
        onOrder && onOrder(detail);
    }
    function handleUpdate(param) {
        onUpdate && onUpdate(param)
    }
    function handleDelete(param) {
        onDelete && onDelete(param)
    }
    function handleOpenList(param) {
        onOpenList && onOpenList(param)
    }

    return (
        <Container>
            <Table>
                <thead>
                    <tr className="header-table-box">
                        <ThBox
                            className={"width-100"}
                            label={"Location Name"}
                            orderKey={"location_name"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-160px"}
                            label={"Province"}
                            orderKey={"province"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-160px"}
                            label={"Latitude"}
                            orderKey={"latitude"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-160px"}
                            label={"Longitude"}
                            orderKey={"longitude"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <ThBox
                            className={"width-180px"}
                            label={"วันที่สร้าง"}
                            orderKey={"created_at"}
                            order={orderOption.order}
                            orderBy={orderOption.orderBy}
                            onSort={handleSort}
                        />
                        <th className="width-70px"></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((value, index) => {
                        return (
                            <TrBox
                                key={index}
                                dataItem={value}
                                onUpdate={handleUpdate}
                                onDelete={handleDelete}
                                onOpenList={handleOpenList}
                            />
                        )
                    })}
                    {rows.length === 0 &&
                        <TrNodataBox />
                    }
                </tbody>
            </Table>
        </Container>
    )
}

function ThBox({
    label,
    orderKey,
    order,
    orderBy,
    onSort,
    className,
}) {
    function handleSort() {
        onSort && onSort(orderKey)
    }
    return (
        <th className={`${className}`}>
            <div className="header-div vertical-center" onClick={handleSort}>
                {label}
                {orderBy === orderKey &&
                    <img
                        className={`image-arrow ${order === "DESC" ? "" : "open"}`}
                        alt="img"
                        src={IconArrow}
                    />
                }
            </div>
        </th>
    )
}

function TrBox({
    dataItem,
    onUpdate,
    onDelete,
    onOpenList,
}) {

    function handleUpdate() {
        onUpdate && onUpdate(dataItem)
    }
    function handleDelete() {
        onDelete && onDelete(dataItem)
    }
    function handleOpenList() {
        onOpenList && onOpenList(dataItem)
    }

    return (
        <tr className="row-table-box">
            <td>{dataItem?.location_name || '-'}</td>
            <td>{dataItem?.province || '-'}</td>
            <td>{dataItem?.latitude || '-'}</td>
            <td>{dataItem?.longitude || '-'}</td>
            <td>{dataItem?.created_at || '-'}</td>
            <td>
                <div className="action-box content-center">
                    <img className="icon-view" alt="img" src={dataItem?.ef_data?.length > 0 ? IconEyeGreen : IconEye} onClick={handleOpenList} />
                    <img className="icon-edit" alt="img" src={IconEdit} onClick={handleUpdate} />
                    <img className="icon-delete" alt="img" src={IconDelete} onClick={handleDelete} />
                </div>
            </td>
        </tr>
    )
}

function TrNodataBox() {
    return (
        <tr className="row-table-box">
            <td colSpan="7" style={{ textAlign: "center" }}>ไม่มีข้อมูล</td>
        </tr>
    )
}

export default TableLocationComponent;